import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

const ProductPricing = (props) => {
    const {
        type, 
        price, 
        on_offer,
        template_page_settings = {},
        original_price = null,
    } = props;

    const { template_settings } = useSelector((state) => state.globalReducer);

    const from_pricing = (template_settings?.from_pricing == 'yes' || template_page_settings?.from_pricing == 'yes'  ? 'yes' : 'no')
    const suffix_status = (template_settings?.suffix_status == 'yes' || template_page_settings?.suffix_status == 'yes' ? 'yes' : 'no');
    const suffix = () => suffix_status == 'yes' && (
        <Typography component="span" className="" color="secondary" sx={{fontSize:16}}>
            &nbsp;{template_settings?.suffix_string || template_page_settings?.suffix_string || ""}
        </Typography>
    )

    
    const hasDiscount = original_price != price;

    return (
        <span>
            {hasDiscount && (
                <span className="strikethrough text-vertical" >
                    {original_price} {suffix()}
                </span>
            )}
            <span className="text-vertical">
                {!type || type == 'has_offer' && from_pricing == 'yes' && (
                    <Typography component="span" className="fw-light" color="secondary" sx={{fontSize:12, verticalAlign: 'super'}}>
                        From &nbsp;
                    </Typography>
                )}
                <Typography component="span" className="fw-bold " color={on_offer ? "error" : "secondary"} sx={{fontSize:'1.5rem'}}>
                    {price} 
                </Typography>
            
                {suffix()}
            </span>
        </span>
    )
}

export default ProductPricing